import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/aalzahr/mwc-components-common/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
/**
 * retrieve an mwc project namespace
 * @param {string} ns namespace for mwc project
 * @example getNamespace('abc')
 * @returns {object|map} namespace
 */

export function getNamespace() {
  var ns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UIA';
  if (typeof ns !== 'string') throw new Error('Namespace should be a string');
  window.mwc[ns] = window.mwc[ns] || new Map();
  var namespace = window.mwc[ns];
  return namespace;
}
/**
 * Loads a dependency and stores in namespace cache for later use
 * @param {string} dependencyName Dependency Key
 * @param {function} promiseFn Function that returns a promise
 * @param {object} options
 * @param {string} options.namespace Custom namespace object or string
 * @param {boolean} options.deferLoading Store promise function to resolve when called again later
 */

export function loadDependency(_x, _x2) {
  return _loadDependency.apply(this, arguments);
}
/**
 *
 * @param {string} tagName custom element tag name
 * @param {promise} importPromise async chunk
 */

function _loadDependency() {
  _loadDependency = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(dependencyName, promiseFn) {
    var _ref,
        namespace,
        _ref$deferLoading,
        deferLoading,
        ns,
        dependency,
        _args = arguments;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, namespace = _ref.namespace, _ref$deferLoading = _ref.deferLoading, deferLoading = _ref$deferLoading === void 0 ? false : _ref$deferLoading;
            ns = getNamespace();

            if (namespace) {
              ns = typeof namespace === 'string' ? getNamespace(namespace) : namespace(namespace);
            }

            if (!ns.has(dependencyName)) {
              _context.next = 15;
              break;
            }

            dependency = ns.get(dependencyName);

            if (!deferLoading) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", dependency);

          case 7:
            if (!(typeof dependency === 'function' && dependency.deferredResolve)) {
              _context.next = 14;
              break;
            }

            _context.t0 = ns;
            _context.t1 = dependencyName;
            _context.next = 12;
            return dependency();

          case 12:
            _context.t2 = _context.sent;

            _context.t0.set.call(_context.t0, _context.t1, _context.t2);

          case 14:
            return _context.abrupt("return", ns.get(dependencyName));

          case 15:
            if (!deferLoading) {
              _context.next = 18;
              break;
            }

            promiseFn.deferredResolve = true; // eslint-disable-line no-param-reassign

            return _context.abrupt("return", ns.set(dependencyName, promiseFn));

          case 18:
            _context.t3 = ns;
            _context.t4 = dependencyName;
            _context.next = 22;
            return promiseFn();

          case 22:
            _context.t5 = _context.sent;

            _context.t3.set.call(_context.t3, _context.t4, _context.t5);

            return _context.abrupt("return", ns.get(dependencyName));

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadDependency.apply(this, arguments);
}

export function loadCustomElement(_x3, _x4) {
  return _loadCustomElement.apply(this, arguments);
}

function _loadCustomElement() {
  _loadCustomElement = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(tagName, importPromise) {
    var element;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            element = window.customElements.get(tagName);

            if (!window.customElements.get(tagName)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", element);

          case 3:
            return _context2.abrupt("return", loadDependency("components." + tagName, importPromise));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadCustomElement.apply(this, arguments);
}

export default {
  getNamespace: getNamespace,
  loadDependency: loadDependency,
  loadCustomElement: loadCustomElement
};
